import { https } from "@/lib/fetchService";

import type { NotificationsResponse, UnreadCountResponse } from "../types";

/**
 * Fetch notifications from the backend API.
 */
export function fetchNotifications(
  params: { page?: number; limit?: number } = {}
): Promise<NotificationsResponse> {
  return https.get<NotificationsResponse>({
    url: "/v1/notifications",
    query: params,
  });
}

/**
 * Fetch the unread notifications count.
 */
export function fetchUnreadCount(): Promise<UnreadCountResponse> {
  return https.get<UnreadCountResponse>({
    url: "/v1/notifications/unread-count",
  });
}

/**
 * Mark a single notification as read.
 */
export function markNotificationAsRead(
  id: string
): Promise<{ success: boolean }> {
  return https.put<{ success: boolean }>({
    url: `/v1/notifications/${id}/read`,
  });
}

/**
 * Mark all notifications for the organization as read.
 */
export function markAllNotificationsAsRead(): Promise<{ success: boolean }> {
  return https.put<{ success: boolean }>({
    url: "/v1/notifications/read-all",
  });
}
